import type { PerformedBy, ProcessStatus, RaciLetter } from '@process-hub/shared';

export const PERFORMER_LABEL: Record<PerformedBy, string> = { human: 'Human', agent: 'Agent', hybrid: 'Hybrid' };

export function Performer({ value }: { value: PerformedBy }) {
  return <span className={`performer performer--${value}`}>{PERFORMER_LABEL[value]}</span>;
}

export const STATUS_LABEL: Record<ProcessStatus, string> = {
  Draft: 'Draft',
  InApproval: 'In approval',
  Published: 'Published',
  Stale: 'Stale',
  Orphaned: 'Orphaned',
  Retired: 'Retired',
};

export function StatusPill({ status }: { status: ProcessStatus }) {
  return <span className={`pill pill--status-${status}`}>{STATUS_LABEL[status]}</span>;
}

/** What each RACI letter means — shown on hover wherever a letter appears. */
export const RACI_DEFINITIONS: Record<RaciLetter, { title: string; meaning: string }> = {
  R: { title: 'Responsible', meaning: 'Does the work of this step.' },
  A: { title: 'Accountable', meaning: 'Owns the outcome and signs it off. Exactly one role per step.' },
  C: { title: 'Consulted', meaning: 'Gives input before the step is done; two-way conversation.' },
  I: { title: 'Informed', meaning: 'Told about the result afterwards; one-way.' },
};

export function raciTitle(letters: readonly RaciLetter[]): string {
  return letters.map((l) => `${l} = ${RACI_DEFINITIONS[l].title}: ${RACI_DEFINITIONS[l].meaning}`).join('\n');
}

export function minutes(n: number | null): string {
  if (n === null) return '—';
  if (n < 60) return `${n} min`;
  if (n < 60 * 24) return `${(n / 60).toFixed(n % 60 ? 1 : 0)} h`;
  return `${(n / 60 / 24).toFixed(n % (60 * 24) ? 1 : 0)} d`;
}
